const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Nfc24 = function Nfc24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M4.014 16.487a1 1 0 0 1-.866-1.5c.53-.901.808-1.928.806-2.973a5.844 5.844 0 0 0-.804-2.968A1 1 0 0 1 4.849 8a7.925 7.925 0 0 1 1.107 4.022 7.9 7.9 0 0 1-1.078 3.968 1 1 0 0 1-.864.497zm5.3 1.674a12.26 12.26 0 0 0 1.66-6.144A12.246 12.246 0 0 0 9.31 5.873a1 1 0 0 0-1.771.927 10.261 10.261 0 0 1 1.433 5.218 10.26 10.26 0 0 1-1.4 5.142 1 1 0 0 0 1.729 1l.013.001zm4.424 2.17a16.581 16.581 0 0 0 2.252-8.314A16.57 16.57 0 0 0 13.729 3.7a1 1 0 0 0-1.779.909 14.582 14.582 0 0 1 2.038 7.404A14.568 14.568 0 0 1 12 19.329a1 1 0 0 0 1.677 1.087c.018-.028.035-.058.051-.088l.01.003zM18.16 22.5A20.9 20.9 0 0 0 21 12.017a20.9 20.9 0 0 0-2.845-10.481 1 1 0 0 0-1.77.925A18.9 18.9 0 0 1 19 12.017a18.919 18.919 0 0 1-2.573 9.483 1 1 0 0 0 1.362 1.365 1 1 0 0 0 .366-.366l.005.001z",
      fill: "currentColor",
    })
  );
};
Nfc24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Nfc24,
};
export function Nfc(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Nfc' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
